import React, { useContext, useState, useEffect } from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import * as deviceService from './deviceService';
import * as modalDataService from './add-device-modal/modalDataService';
import { showSuccessToast, showWarningToast } from "../validation/ToastContainer";
import { useDeviceTableHelper } from "./useDeviceTableHelper";
import GroupsDropdown from "./GroupsDropdown";
import { PopupContext, TableContext } from "../index";
import { getRemoveDevicePopup } from "../view/popup/PopupContainer";
import { INFO_BOXES_REFRESH_EVENT } from "../info-boxes/InfoBoxes";
import { Plus, Trash2, Download, Filter } from 'lucide-react';
import SearchInputV2 from "../view/SearchInputV2";

function DevicesTableHeader({ userCapability }) {

    const { setPopup } = useContext(PopupContext);
    const { config, setConfig } = useContext(TableContext);
    const devicesTableHelper = useDeviceTableHelper();

    //#region Set User Capabilities
    const [addDeviceCapability, setAddDeviceCapability] = useState(-1);
    const [removeDeviceCapability, setRemoveDeviceCapability] = useState(-1);
    const [exportDataCapability, setExportDataCapability] = useState(-1);
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        if (userCapability) {
            const addDevicePermission = userCapability.find(item =>
                item.component === "adddevice" && item.type === "field")?.permission;
            setAddDeviceCapability(addDevicePermission);

            const removeDevicePermission = userCapability.find(item =>
                item.component === "removedevice" && item.type === "field")?.permission;
            setRemoveDeviceCapability(removeDevicePermission);

            const exportDataPermission = userCapability.find(item =>
                item.component === "exportdata" && item.type === "field")?.permission;
            setExportDataCapability(exportDataPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const onAddDeviceClick = () => {
        modalDataService.showModal();

    }

    const onRemoveDeviceClick = () => {
        const onConfirm = () => {
            if (!config.selected || config.selected.length === 0) {
                return showWarningToast('No selected devices to delete', 'Remove Device', 'aborted');
            }
            deviceService.remove(config.selected)
                .then(() => {
                    devicesTableHelper.hardReload();
                    window.dispatchEvent(new Event(INFO_BOXES_REFRESH_EVENT));
                    showSuccessToast('Selected devices were removed', 'Remove Device', 'success');
                });
        }

        setPopup(
            getRemoveDevicePopup(
                'Remove Device',
                config.selected ? config.selected.length : 0,
                () => onConfirm()
            )
        );
    }

    //Added by Octopus DevTeam july 13-2022
    const exportData = () => {
        // eslint-disable-next-line no-unused-vars
        deviceService.exportDevicesData();
        // const x = deviceService.listPageable().then((allDevices) => {
        //     //alert(config.devices[0]);
        //     const devices = allDevices.devices;
        //     deviceService.exportDevicesData(devices);
        // });
    }

    // Search handler - client-side filtering via config
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    }

    // Check if any devices are selected
    const hasSelectedDevices = config.selected && config.selected.length > 0;
    const isRemoveDisabled = removeDeviceCapability === 0 || !hasSelectedDevices;

    return (
        <div className="devices-header-v2">
            <div className="devices-header-content">
                <div className="devices-left-section">
                    <h2 className="devices-title-v2">Devices List</h2>

                    <div className="devices-filter-group-v2">
                        <button type="button" className="oct_btn-filter-v2">
                            <Filter className="oct_icon" />
                            GROUP
                        </button>
                        <GroupsDropdown />
                    </div>
                </div>

                <div className="devices-actions-v2">
                    <button type="button"
                        className="oct_btn-primary-v2"
                        disabled={addDeviceCapability === 0 ? true : false}
                        onClick={addDeviceCapability === 0 ? null : () => onAddDeviceClick()}>
                        <Plus className="oct_icon" />
                        Add Device
                    </button>

                    <button type="button"
                        className="oct_btn-danger-v2"
                        disabled={isRemoveDisabled}
                        onClick={isRemoveDisabled ? null : () => onRemoveDeviceClick()}>
                        <Trash2 className="oct_icon" />
                        Remove Device
                    </button>

                    <button type="button"
                        className="oct_btn-export-v2"
                        disabled={exportDataCapability === 0 ? true : false}
                        onClick={exportDataCapability === 0 ? null : () => exportData()}>
                        <Download className="oct_icon" />
                        Export Data
                    </button>
                </div>
            </div>

            <SearchInputV2
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Search by host name or IP address..."
            />
        </div>
    );
}

function mapStateToProps(state) {
    debug("DevicesTableHeader mapStateToProps", state);
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    };
}

export default connect(mapStateToProps)(DevicesTableHeader);
